import React from 'react';
import Carousel from 'nuka-carousel';
import Div100vh, { use100vh } from 'react-div-100vh';
import { BG, Nav as NavWrapper } from './hero.css';
import Nav from '../nav/nav';
import Lauv from '../../../static/hero-lauv.jpg';
import Together from '../../../static/hero-together.jpg';
import Lauv2 from '../../../static/hero-lauv2.jpg';

const Hero = () => {
  const height = use100vh();
  return (
    <Div100vh>
      <NavWrapper className="wrapper">
        <Nav />
      </NavWrapper>
      <Carousel
        autoplay
        autoplayInterval={4200}
        pauseOnHover={false}
        wrapAround
        speed={480}
        swiping={false}
        dragging={false}
        renderBottomCenterControls={() => null}
        renderCenterLeftControls={() => null}
        renderCenterRightControls={() => null}
        style={{
          backgroundColor: '#f921ab',
        }}
      >
        <BG dynamicHeight={height}>
          <div className="albumContainer bottomAlign">
            {/* <p className="promoText">Additional Promo Text Here</p> */}
            <a
              className="heroCta"
              href="https://lauv.ffm.to/fake"
              target="_blank"
              rel="noopener noreferrer"
            >
              Listen Now
            </a>
          </div>
        </BG>
        <BG dynamicHeight={height} secondary>
          <div className="albumContainer photoBlock">
            <div className="photoContainer">
              <img src={Lauv2} alt="Lauv" />
              <img src={Together} alt="Together" className="hideMobile" />
              <img src={Lauv} alt="Lauv" />
            </div>
          </div>
        </BG>
      </Carousel>
    </Div100vh>
  );
};

export default Hero;
